<template>
    <transition name="custom-classes-transition"
                enter-active-class="animated fadeInUp"
                leave-active-class="animated fadeOut">
    <div class="gallery" v-if="show && versionDefault">
        <b-input-group>
            <b-container fluid class="p-1 mx-2">
            <label class="button-add-image" v-if="!isLimitImages">
                + Add Image<input type="file" @change="updateGallery" hidden :disabled="isLimitImages">
            </label>
            <b-row>
            <transition-group name="list" mode="out-in" tag="div">
            <label
                class="image-gallery-span"
                v-for="(image, imageIndex) in gallery"
                :key="image.id"
                v-b-modal.gallery
                @click="index = imageIndex"
                :style="{ backgroundImage: 'url(' + toObjectURL(image) + ')', width: '300px', height: '200px' }"
            >
            </label>
            </transition-group>

            <!-- Modal Gallery -->
                <b-modal
                id="gallery"
                hide-header
                centered
                body-class="gallery-modal-body"
                footer-class="gallery-modal-footer">
                <b-img fluid-grow :src="urlRenderImage"></b-img>
                <div class="p-0 m-0" slot="modal-footer">
                    <b-button @click="hideGalleryModal" size="sm" variant="outline-secondary"> <i class="fa fa-chevron-left" aria-hidden="true"></i>
                    Close
                    </b-button>
                    <b-button @click="removeImageGallery" class="ml-2 remove-image" size="sm" variant="outline-danger"> <i class="fa fa-times" aria-hidden="true"></i>
                    Remove
                    </b-button>
                </div>
                </b-modal>
            </b-row>
            </b-container>
        </b-input-group>
    </div>
    <!-- prop : versionDefault=false -->
    <div class="gallery gallery-extended" v-if="show && !versionDefault">
        <b-input-group>
            <b-container fluid class="p-1 mx-2">
            <transition-group name="list" mode="out-in" tag="p" class="p-extended">
            <span
                class="image-gallery-span"
                v-for="(image, imageIndex) in gallery"
                :key="image.id"
                v-b-modal.gallery
                @click="index = imageIndex"
                :style="{ backgroundImage: 'url(' + toObjectURL(image) + ')', width: '159px', height: '282px' }"
            >
            </span>
            </transition-group>
            <label class="button-add-image button-add-image-extended" v-if="!isLimitImages">
                <li class="fa fa-plus fa-plus-extended"></li> Add Image<input type="file" @change="updateGallery" hidden :disabled="isLimitImages">
            </label>
            <b-row>
            <!-- Modal Gallery -->
                <b-modal
                id="gallery"
                hide-header
                centered
                body-class="gallery-modal-body"
                footer-class="gallery-modal-footer">
                <b-img fluid-grow :src="urlRenderImage"></b-img>
                <div class="p-0 m-0" slot="modal-footer">
                    <b-button @click="hideGalleryModal" size="sm" variant="outline-secondary"> <i class="fa fa-chevron-left" aria-hidden="true"></i>
                    Close
                    </b-button>
                    <b-button @click="removeImageGallery" class="ml-2 remove-image" size="sm" variant="outline-danger"> <i class="fa fa-times" aria-hidden="true"></i>
                    Remove
                    </b-button>
                </div>
                </b-modal>
            </b-row>
            </b-container>
        </b-input-group>
    </div>
    <!--End-->
    </transition>
</template>

<script>
import uniqid from 'uniqid';

export default {
  props: {
    show: { type: Boolean, default: true },
    gallery: { type: Array, required: true },
    removeGallery: { type: Array, required: true },
    limitGallery: { type: Number, default: 5 },
    versionDefault: { type: Boolean, default: true }
  },
  data () {
    return {
      index: null
    };
  },
  methods: {
    updateGallery (e) {
      const file = e.target.files[0];
      if (file) {
        this.gallery.push({ id: uniqid('image-'), file: file });
      }
    },
    toObjectURL (file) {
      if (!file) {
        return null;
      }
      if (file.url) {
        return file.url;
      } else {
        return URL.createObjectURL(file.file);
      }
    },
    hideGalleryModal () {
      this.$bvModal.hide('gallery');
    },
    removeImageGallery () {
      this.$bvModal.hide('gallery');
      const index = this.index;
      this.index = null;
      const image = this.gallery[index] || { id: null };

      if (image.id && -1 === image.id.indexOf('image-')) {
        this.removeGallery.push(image.id);
      }
      this.gallery.splice(index, 1);
    }
  },
  computed: {
    isLimitImages () {
      return this.gallery.length >= this.limitGallery;
    },
    urlRenderImage () {
      const index = this.index;
      if (null == index) {
        return null;
      }
      const gallery = this.gallery[index] || {};
      if (gallery.url) {
        return gallery.url;
      } else {
        return URL.createObjectURL(gallery.file);
      }
    }
  }
};
</script>

<style>
    input[type=file]:hover{
      cursor: pointer;
    }
    .image-gallery-span {
      float: left;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      margin: 5px;
      -webkit-box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.75);
      -moz-box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.75);
      box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.75);
    }
    .image-gallery-span:hover {
      cursor: pointer;
    }
    a.prev, a.next, a.close {
      color: #FFF !important;
    }
    .button-add-image{
      font-size: 12px;
      height: 40px;
      padding: 10px 24px;
      -webkit-box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.75);
      -moz-box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.75);
      box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.75);
      border-radius: 4px;
      color: #73818f;
      margin-left: -8px;
    }

    .button-add-image:hover{
      cursor: pointer;
      -webkit-box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.877);
      -moz-box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.877);
      box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.877);
    }
    .gallery-modal-body{
      margin: 0;
      padding: 0;
    }
    .gallery-modal-footer{
      padding-top: 3px;
      padding-bottom: 3px;
    }
    /*Not-default*/
    .button-add-image-extended {
      border: 1px dashed #339DAA !important;
      padding-top: 65px !important;
      padding-bottom: 65px !important;
      background-color: #ffffff !important;
      color: #339DAA;
      box-shadow: none !important;
      margin-left: 2px;
      margin-top: -3px;
      text-align: center;
      width: 159px;
      height: 282px;
    }
    .fa-plus-extended {
      width: 100%;
      text-align: center;
      margin-top: 59px;
    }
    .p-extended {
      margin-bottom: 0.5rem;
    }

    .gallery-extended {
      margin-left: -26px;
    }
    .inline-column-group {
      display: inline-block;
    }
</style>

<style scoped>
    .list-enter-active {
      transition: 1s ease;
    }

    .list-leave-active {
      transition: opacity 1s ease;
      position: absolute;
    }

    .list-enter,
    .list-leave-to {
      opacity: 0;
      background-color: red;
      transform: translateY(10px);
    }

    .list-move {
      transition: 2s ease;
    }
</style>
